export enum TasksStatus {
  all = 'All',
  new = 'New',
  inProgress = 'In Progress',
  stuck = 'Stuck',
  done = 'Done',
  overdue = 'Overdue',
  na = 'N/A',
}

export enum TaskType {
  Listing = 'Listing',
  Purchase = 'Purchase',
  Dual = 'Dual',
  Project = 'Project',
}

export type TaskFiltersType = {
  startDate;
  endDate;
  taskStatuses: TasksStatus[];
  taskTypes: TaskType[];
};

export const initialTasksFilters: TaskFiltersType = {
  startDate: null,
  endDate: null,
  taskStatuses: [TasksStatus.new, TasksStatus.inProgress, TasksStatus.stuck, TasksStatus.overdue],
  taskTypes: [],
};

export type PreparedTaskType = {
  Id: number;
  Description: string;
  DueDate;
  DueDateWithTime;
  PropertyAddress;
  Status: string;
  StatusId: number;
  Title: string;
  Transaction;
  Type: string;
  SubType: string;
  TransactionName: string;
  FormattedDate;
};

export type TaskTransactionAccess = {
  MemberId: number;
  Tasks: {
    TaskId: number;
    TransactionId: number;
    FullAccess: null | boolean;
    AddAsParticipant: boolean;
    RoleId: null | number;
    TransactionName: string;
  }[];
};

export const permissionOptions = [
  {
    name: 'Full Access',
    value: 'Full',
  },
  {
    name: 'Limited Access',
    value: 'Limited',
  },
];

export type TaskReassignmentPayloadType = {
  TaskId: number;
  TransactionId: number;
  Assignees: {
    AssigneeId: number;
    FullAccess: boolean;
    AddAsParticipant: boolean;
    RoleId: null | number;
  }[];
};
